module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_design.bc36a776.svg";